import { render, staticRenderFns } from "./unmannedAerialVehicleDetail.vue?vue&type=template&id=33b99f9a&scoped=true&"
import script from "./unmannedAerialVehicleDetail.vue?vue&type=script&lang=js&"
export * from "./unmannedAerialVehicleDetail.vue?vue&type=script&lang=js&"
import style0 from "./unmannedAerialVehicleDetail.vue?vue&type=style&index=0&id=33b99f9a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b99f9a",
  null
  
)

export default component.exports